/**
 * Breakdown of booking status values to populate the stats UI
 */
export default class OverviewStatsDto {
  constructor({ openBookings = 0, totalBookings = 0 } = {}) {
    /**
     * Number of bookings filled
     * @type {Number}
     */
    this.filled = totalBookings - openBookings

    /**
     * Number of total bookings
     * @type {Number}
     */
    this.totalBookings = totalBookings

    /**
     * Number of unfilled bookings
     * @type {Number}
     */
    this.unfilled = openBookings

    const displayNA = openBookings === 0 && totalBookings === 0

    const percentage = (this.filled / totalBookings) * 100
    const skipRounding = percentage <= 0 || isNaN(percentage)

    let fillRate = skipRounding ? 0 : Math.round(percentage)

    if (displayNA) {
      fillRate = -1
    }

    /**
     * Percentage of bookings filled
     * @type {Number}
     */
    this.fillRate = fillRate
  }
}
